import { render, staticRenderFns } from "./ResultHeaderFooterComponent.vue?vue&type=template&id=138ec5ae&scoped=true&"
import script from "./ResultHeaderFooterComponent.vue?vue&type=script&lang=js&"
export * from "./ResultHeaderFooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./ResultHeaderFooterComponent.vue?vue&type=style&index=0&id=138ec5ae&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ec5ae",
  null
  
)

export default component.exports